<template>
    <option v-if="this.tpChamado._id_principal > 0" :class="{ 'desabilitado': !tpChamado.ativo }" class="text-center">
        {{ tpChamado.descricao }}
    </option>
</template>


<script>

export default {
    name: 'FiltroSubTipo',

    props: {
        tpChamado: {}
    },

    data() {
        return {
        };
    },

    mounted() {
        return [

        ];
    },

    components: {

    },

    methods: {

    },

    computed: {


    }
};
</script>

<style scoped>
.desabilitado {
    display: none;
}

.texto {
    text-align: left;
}
</style>